export { default } from '@/features/openTabs/pages/SplitAccountPage'
